import React from "react";
import { Link } from 'react-router-dom';
import images from '../assets/images';
import scrollTo from '../helpers/scroll-to';
import LogoutService from './LogoutService';

export default class MobileNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lastPosition: 0
    }
  }
  componentDidMount() {
    this.navElement = document.getElementById("mobile-nav").firstElementChild;
    this.viewWidth = document.getElementById("mobile-nav").offsetWidth;

    new Promise((resolve) => {
      let scrollVar = window.pageYOffset || document.documentElement.scrollTop
      this.setState({lastPosition: scrollVar})
      resolve("done")
    }).then(() => {
      window.scrollTo(0,0)
    })
    this._slideIn(0, this.viewWidth, () => {this.setState({on: false})})
  }
  _slideIn = (counterWidth, last, cb) => {
    if (last < counterWidth) {
      setTimeout(() => {
        this.navElement.style.width = `${last}px`;
      }, 0 + (last / 2));
      return this._slideIn(counterWidth, last + 10, cb)
    }
  }
  _slideOut = (last) => {
    document.querySelector('.gpa-default > div').style.opacity = 1;
    if (document.getElementById("mobile-nav") && last > 0) {
      setTimeout(() => {
        if (parseFloat(document.getElementById("mobile-nav")
            ? (document.getElementById("mobile-nav").style.width.replace('px', ''))
            : '0'
          ) < 10)
        {
          setTimeout(() => {window.scrollTo(this.state.lastPosition, 0);this.props.onClose()}, 10);
        }
        document.getElementById("mobile-nav").style.width = last > 10 ? `${last}px` : '0px';
      });
      return this._slideOut(last - 1)
    }
  }
  logout(e){
    e.preventDefault();
    const logout = new LogoutService();
    logout.userLogout();
  }

  render() {
    return (
      <nav id="mobile-nav" className="navbar-mobile bg-white " style={{ overflow: 'auto', height: window.innerHeight, ...this.props.style  }}>
        <ul className='nav navbar-nav font-2 bg-white'>
          <li className="border-0 pt-3 pr-2">
            <i className="material-icons text-loyalty float-right font-30" onClick={() => { this._slideOut(this.viewWidth) }}>close</i>
          </li>
          {/* <li className="nav-item pt-1 pl-3 pb-3" onClick={() => {this.props.onClose()}}>
            {localStorage.logged
              ? <div className="user-area">
                  <i className="material-icons person bg-loyalty text-white text-center mr-3">person</i>
                  {localStorage.username}
                </div>
              : <a href="?modal=login" className="text-black d-block" onClick={this.props.actionsModal('open', 'LOGIN')}>Entre</a>
            }
          </li>
          <li className={!localStorage.logged ? "nav-item border-top p-3 d-block" : "d-none"}>
            <a href="/register?origin=mais" className="text-black d-block">Cadastre-se</a>
          </li>
          <li className={localStorage.logged ? "nav-item border-top p-3 d-block" : "d-none"}>
            <a href="/user-info/profile?origin=mais" className="text-black d-block mt-2">Alterar Cadastro</a>
          </li> */}
          {this.props.links.map((link, i) => {
            const isModal = link.modalName ? true : false;
            return (
              <li key={i} className="nav-item border-top p-3" onClick={() => {this.props.onClose(isModal ? 'hidden' : 'auto')}}>
                { link.desc == "FAQ"
                  ? <a className="nav-link text-black d-block" href={link.href}>{link.desc}</a>
                  : <a className="nav-link text-black d-block" href={link.href} onClick={isModal ? this.props.actionsModal('open', link.modalName) : scrollTo(link.hash)}>
                      {link.desc}
                    </a>
                }
              </li>
            );
          })}
          {/* <li className={localStorage.logged ? "nav-item border-top p-3 d-block" : "d-none"}>
            <a href="" className="text-black d-block mt-2" onClick={this.logout}>Sair</a>
          </li>
          <li className="border-0 bg-loyalty font-16">
            <div className="float-left text-center text-white w-50 mt-3">
              <a href="http://faleconosco.grupopaodeacucar.com.br/pdamais/home/faleconosco" target="_blank">
                <img
                  className="d-block m-auto"
                  src={images.icons.airplane_white}
                  alt="avião de papel"
                />
                <span className="d-block mt-3 text-white">Enviar uma</span>
                <span className="font-weight-bold text-white">mensagem</span>
              </a>
            </div>
            <div className="float-left text-center text-white w-50 mt-3 pr-4">
              <a href="tel:08007732624" className="text-white">
                <img
                  className="d-block m-auto"
                  src={images.icons.phone_white}
                  alt="telefone"
                />
                <span className="d-block mt-3">Ligue para</span>
                <span className="font-weight-bold">0800 77 32 624</span>
              </a>
            </div>
          </li> */}
        </ul>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileNav.js